<template>
  <div :class="classList">
    <div v-if="!loading && ready">
      <vuetable
        :class="tableClassObject"
        :api-mode="false"
        ref="vuetable"
        :fields="table.fields"
        :data-manager="dataManager"
        detail-row-component="document-detail-row"
        track-by="id"
        @vuetable:row-clicked="onRowClick"
        no-data-template="<br>No documents were found.<br><br>"
        pagination-path
        @vuetable:pagination-data="onPaginationData"
      >
        <template slot="document-name" slot-scope="props">
          <div class="c-data-table__cell-icon">
            <file-icon
              v-if="
                props.rowData.current_version &&
                  props.rowData.current_version.file &&
                  !props.rowData.current_version.external_url
              "
              :type="props.rowData.current_version.file.name | extension"
            ></file-icon>
            <file-icon
              v-else-if="props.rowData.current_version.external_url"
              type="link"
            />
            <file-icon v-else type="file"></file-icon>
            <span data-click="true">{{
              props.rowData.current_version.title
            }}</span>
          </div>
        </template>

        <template slot="review-date" slot-scope="props">
          <span>{{$dayjs(props.rowData.current_version.review_date).format(
                'DD / MM / YYYY'
              )}}</span>
        </template>

        <template slot="policy-version" slot-scope="props">
          <div v-if="!isAdmin" class="t-version t-version__simple">
            {{ props.rowData.current_version.version }}
          </div>
        </template>


        <template slot="document-version" slot-scope="props">
          <div
            class="t-version"
            @click.stop.prevent="toggleDetailRow(props.rowData)"
            v-if="canShowDropdown(props.rowData) || isAdmin"
          >
            <base-tooltip fill-container text="See versions">
              <span class="t-version__text">{{
                props.rowData.current_version.version
              }}</span>
            </base-tooltip>
            <div class="t-version__dropdown">
              <icon name="drop-arrow" width="8" height="8"></icon>
            </div>
          </div>
          <div v-else class="t-version ">
            {{ props.rowData.current_version.version }}
          </div>
        </template>

      </vuetable>
      <pagination table-pagination>
        <vuetable-pagination
          ref="pagination"
          @vuetable-pagination:change-page="onChangePage"
        ></vuetable-pagination>
      </pagination>
    </div>
    <loading v-else></loading>
  </div>
</template>

<script>
import Vue from 'vue';

import DocumentActions from './DocumentActions';
import DocumentDetailRow from './DocumentDetailRow';
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
import Pagination from '@/components/pagination';
import querySearch from '@/mixins/querySearch';

Vue.component('document-actions', DocumentActions);
Vue.component('document-detail-row', DocumentDetailRow);

export default {
  name: 'documents-table',

  mixins: [querySearch],

  data() {
    return {
      ready: false,
      table: {
        fields: [
          {
            name: 'document-name',
            title: 'Document Name',
            titleClass: 'u-ta-left',
            dataClass: 'u-ta-left title-col',
            width: '35%',
          },
          {
            name: 'primary_category.name',
            title: 'Category',
            titleClass: 'u-hide-mobile u-ta-center',
            dataClass: 'u-hide-mobile u-ta-center',
            width: '12%',
          },
          {
            name: 'review-date',
            title: 'Review Date',
            titleClass: 'u-ta-center u-hide-mobile',
            dataClass: 'u-ta-center u-hide-mobile',
            width: '10%',
          },
          {
            name: DocumentActions,
            title: 'Actions',
            titleClass: 'u-ta-center u-hide-mobile',
            dataClass: 'u-ta-center u-hide-mobile',
            width: '9%',
          },
        ],
      },
    };
  },

  created() {
    if (
      this.docType.singular == 'policy' &&
      !['pending', 'rejected'].includes(this.tabFilter) &&
      this.$route.meta.isAdmin
    ) {
      const policyNumberField = {
        name: `${this.docType.singular}_number`,
        title: 'Number',
        titleClass: 'u-ta-center u-hide-mobile',
        dataClass: 'u-ta-center u-hide-mobile',
        width: '15%',
      };

      const versionNum = {
        name: 'document-version',
        title: 'Version',
        titleClass: 'u-ta-center u-hide-mobile',
        dataClass: 'u-hide-mobile u-ta-center u-pos-relative t-version-wrapper',
        width: '10%',
      };

      this.table.fields.splice(2, 0, policyNumberField);

      if (this.$route.meta.isAdmin) {
        this.table.fields.splice(1, 0, versionNum);
      }
    }
    if (this.docType.singular == 'policy' && !this.$route.meta.isAdmin) {
      const versionPolicyNum = {
        name: 'policy-version',
        title: 'Version',
        titleClass: 'u-hide-mobile',
        dataClass: 'u-hide-mobile',
        width: '7%',
      };
      if (!this.$route.meta.isAdmin) {
        this.table.fields.splice(1, 0, versionPolicyNum);
      }
    }

    if (
      this.docType.singular == 'form' &&
      !['rejected'].includes(this.tabFilter) &&
      this.$route.meta.isAdmin
    ) {
      const versionNum = {
        name: 'document-version',
        title: 'Version',
        titleClass: 'u-ta-center u-hide-mobile',
        dataClass: 'u-hide-mobile u-ta-center u-pos-relative t-version-wrapper',
        width: '10%',
      };

      if (this.$route.meta.isAdmin) {
        this.table.fields.splice(1, 0, versionNum);
      }
    }

    this.ready = true;
  },

  methods: {
    canShowDropdown(rowData) {
      return this.$route.meta.isAdmin && rowData.version_count > 1;
    },
    onHeaderEvent(type, payload) {
      //
    },

    fieldEvent(event) {
      //
    },

    dataManager(sortOrder, pagination) {
      const returnObj = {
        ...this.$store.state.documents.pagination,
        data: this.documents[this.docType.plural],
      };

      return returnObj;
    },

    onRowClick(dataItem) {
      if (
        dataItem.event.target.localName === 'td' ||
        dataItem.event.target.parentNode.localName === 'td' ||
        dataItem.event.target.dataset.click == 'true'
      ) {
        this.$emit('rowClick', dataItem);
      }
    },

    toggleDetailRow(dataItem) {
      this.$refs.vuetable.toggleDetailRow(dataItem.id);
    },
    onPaginationData(paginationData) {
      paginationData.current_page = this.getCurrentPageNumber('documents');
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      const vm = this;
      const tableref = vm.$refs.vuetable;
      let nextPage;
      /**
       * Because why would the plugin send actual page numbers
       */
      switch (page) {
      case 'next':
        nextPage = ++this.$store.state.documents.pagination.current_page;
        break;
      case 'prev':
        nextPage = --this.$store.state.documents.pagination.current_page;
        break;
      default:
        nextPage = page;
        break;
      }
      this.updatePageQuery('documents', nextPage);

      this.$store.dispatch('documents/list').then((resp) => {
        window.scroll(0, 0);
        tableref.changePage(page);
      });
    },
  },

  computed: {
    classList() {
      return {
        'c-documents-table': true,
      };
    },

    tableClassObject() {
      return {
        'c-data-table': true,
        [`c-data-table--${this.tabFilter}`]: this.tabFilter,
      };
    },

    tabFilter() {
      return this.$store.state.documents.tabFilter;
    },

    docType() {
      return this.$store.state.documents.docType;
    },

    loading() {
      return this.$store.state.documents.loading;
    },

    documents() {
      return this.$store.state.documents.documents;
    },
    isAdmin() {
      return this.$route.meta.isAdmin;
    },
  },

  components: {
    DocumentDetailRow,
    VuetablePagination,
    Pagination,
  },
};
</script>

<style lang="scss">
.t-version-wrapper {
  padding: 0 !important;
}
.t-version {
  position: relative;
  height: 80px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  &__simple {
    height:auto;
  }
}
.t-version__dropdown {
  border-left: 1px solid $colour-nhs-pale-grey;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 24px;

  display: flex;
  align-items: center;
  justify-content: center;
}

.c-data-table__cell-icon {
  display: flex;
  align-items: center;

  svg {
    min-width: 42px;
  }
}

.title-col {
  max-width: 300px;
}
</style>
